import { GetTransactionsParams } from "@/models/payload/transaction";
import customerGroupService from "@/services/customerGroup";
import { useInfiniteQuery } from "@tanstack/react-query";

type Props = {
  params: GetTransactionsParams;
};

function useGetCustomerGroups({ params }: Props) {
  return useInfiniteQuery({
    queryKey: ["customerGroup", params?.Term],
    queryFn: ({ pageParam = 0 }) =>
      customerGroupService.getCustomerGroups({ ...params, Skip: pageParam }),
    getNextPageParam: (lastPage, allPages) => {
      const morePagesExist = lastPage?.result?.length === params.Count; // Assuming 10 items per page
      if (!morePagesExist) return undefined;
      return allPages.length * (params?.Count || 10); // Next page's skip value
    },
  });
}

export default useGetCustomerGroups;
